import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import { Link } from "react-router-dom";
import Phone from "./Phone";

import { ReactComponent as CompanyLogo } from "../../assets/images/logo.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3, 2, 0, 2.5),
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      maxWidth: "900px"
    },
  },
  logo: {
    filter: "grayscale(1) brightness(5)",
    [theme.breakpoints.up("md")]: {
      width: "160px",
      height: "65px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "120px",
      height: "45px",
    },
  },
  menu: {
    fontSize: "2.4rem",
  },
}));

const Header = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Link to="/reset">
        <CompanyLogo
          className={classes.logo}
          title="Kostenloser Bußgeldcheck"
        />
      </Link>

      <Phone />
    </Box>
  );
};

export default Header;
